<template>
  <div class="hero">
    <lottie :options="defaultOptions" :width="svgWidth()" :height="svgHeight()" @animCreated="handleAnimation"/>
  </div>
</template>

<script>
import Lottie from 'vue-lottie/src/lottie.vue'
import * as animationData from '@/../static/hero.json'

export default {
  name: 'hero',
  components: {
    Lottie
  },
  props: ['heroProps'],
  data: function () {
    return {
      defaultOptions: {
        animationData,
        animationSpeed: 1,
        autoplay: true,
        loop: false
      },
    }
  },
  methods: {
    handleAnimation: function (anim) {
      this.anim = anim
      const props = this.heroProps
      const onComplete = function (evt) {
        if (props && props.onComplete) {
          props.onComplete(evt)
        }
      }
      this.anim.addEventListener('complete', onComplete)
    },
    svgHeight: function () {
      if (this.heroProps && this.heroProps.height && Number.isInteger(this.heroProps.height)) {
        return this.heroProps.height
      }
      return 0
    },
    svgWidth: function () {
      if (this.heroProps && this.heroProps.width && Number.isInteger(this.heroProps.width)) {
        return this.heroProps.width
      }
      return 0
    },
  },
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Hero.vue